//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderCreateApi, folderMakeApi, folderSpaceEntCreateApi, folderSpaceEntMakeApi } from '@/api/cloud';
export default {
  name: 'MyFileDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      info: {
        name: '',
        type: ''
      },
      options: [{
        label: '文档',
        value: 'word'
      }, {
        label: '表格',
        value: 'excel'
      }, {
        label: '幻灯片',
        value: 'ppt'
      }],
      loading: false
    };
  },
  computed: {},
  watch: {
    config: {
      handler: function handler(nVal) {
        this.info.type = this.config.type;
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.info.name = '';
      this.info.type = '';
      this.dialogVisible = false;
    },
    handleAdd: function handleAdd() {
      var _this = this;
      // 创建文件夹
      if (this.config.command === 5) {
        if (this.info.name === '') {
          this.$message.error('文件夹名称不能空');
        } else {
          var data = {
            pid: this.config.pid,
            name: this.info.name
          };
          if (this.config.switch === 6) {
            // 企业空间文件夹创建
            this.loading = true;
            folderSpaceEntMakeApi(this.config.spaceId, data).then(function (err) {
              _this.handleClose();
              _this.loading = false;
              _this.$emit('handleIsOK');
            }).catch(function (error) {
              _this.loading = false;
            });
          } else {
            // 我的空间文件夹创建
            this.loading = true;
            folderMakeApi(data).then(function (err) {
              _this.handleClose();
              _this.loading = false;
              _this.$emit('handleIsOK');
            }).catch(function (error) {
              _this.loading = false;
            });
          }
        }
      } else {
        if (this.info.name === '') {
          this.$message.error('文件名称不能空');
        } else {
          var _data = {
            pid: this.config.pid,
            name: this.info.name,
            type: this.info.type
          };
          if (this.config.switch === 6) {
            // 企业空间文件创建
            this.loading = true;
            folderSpaceEntCreateApi(this.config.spaceId, _data).then(function (err) {
              _this.handleClose();
              _this.loading = false;
              _this.$emit('handleIsOK');
            }).catch(function (error) {
              _this.loading = false;
            });
          } else {
            this.loading = true;
            // 我的空间文件创建
            folderCreateApi(_data).then(function (err) {
              _this.handleClose();
              _this.loading = false;
              _this.$emit('handleIsOK');
            }).catch(function (error) {
              _this.loading = false;
            });
          }
        }
      }
    }
  }
};